import { api } from '../../../utils/api.ts';

type UseDetailQuoteOrderOptions = {
    transactionId: string;
    /** `false` defers the request until the caller actually needs the detail. */
    enabled?: boolean;
};

export function useDetailQuoteOrder({ transactionId, enabled }: UseDetailQuoteOrderOptions) {
    return api.platoUser.grid.getDetailQuoteOrder.get.useQuery(
        { id: transactionId },
        { refetchOnMount: false, enabled },
    );
}
